import React, { useState } from "react";
import { useGetUserListQuery } from "@/redux/services/recordApi";
import { Alert, Spin, DatePicker, Select, Flex } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { RecordTable, EditRecordTable } from "./recordTable";
import { ROLE } from "@/router/role.constant";

const monthFormat = "YYYY/MM";
const ReportPage = () => {
	const { role, userId } = useSelector((state) => state.auth.user);
	const [selectedDate, setSelectedDate] = useState(
		dayjs().format(monthFormat)
	);
	const [selectedUserId, setSelectedUserId] = useState();

	const {
		data: userList,
		isLoading,
		isError,
	} = useGetUserListQuery(
		{
			roleId: 2,
		},
		{
			skip: role !== ROLE.admin,
		}
	);

	if (isLoading) {
		return <Spin tip="Loading..." size="large"></Spin>;
	}

	if (isError) {
		return (
			<Alert
				message="Fail to get user list"
				description=""
				type="error"
			/>
		);
	}

	return (
		<Flex vertical gap="large">
			<DatePicker
				style={{
					width: "200px",
				}}
				defaultValue={dayjs(selectedDate, monthFormat)}
				format={monthFormat}
				picker="month"
				onChange={(date, dateString) => {
					setSelectedDate(dateString);
				}}
				allowClear={false}
			/>
			{role === ROLE.admin ? (
				<Flex vertical gap="large">
					<Select
						style={{
							width: "100%",
						}}
						showSearch
						placeholder="Select a user"
						optionFilterProp="children"
						onChange={(value) => {
							setSelectedUserId(value);
						}}
						filterOption={(input, option) =>
							(option?.label ?? "")
								.toLowerCase()
								.includes(input.toLowerCase())
						}
						options={
							userList?.user_list.map((user) => {
								return {
									...user,
									value: `${user.id}`,
									label: `${user.name}${
										user.email ? ` - ${user.email}` : ""
									}`,
								};
							}) ?? []
						}
						allowClear={true}
					/>
					<EditRecordTable
						selectedUserId={selectedUserId}
						year={dayjs(selectedDate).year()}
						month={dayjs(selectedDate).month() + 1}
					/>
				</Flex>
			) : (
				<RecordTable
					selectedUserId={userId}
					year={dayjs(selectedDate).year()}
					month={dayjs(selectedDate).month() + 1}
				/>
			)}
		</Flex>
	);
};

export default ReportPage;
